var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMini = function SvgLogoMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B463",
    d: "M19 38c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.54 30.693a9.44 9.44 0 0 1-7.308-3.45 8.6 8.6 0 0 1-2.154-5.713v-6.944h4.262v6.435c0 2.852 2.324 5.194 5.176 5.226h.055c2.852-.027 5.167-2.374 5.167-5.226v-6.43l-.505-.005h-2.274l4.878-6.177 4.767 6.177H28v6.945a8.66 8.66 0 0 1-2.255 5.832 9.45 9.45 0 0 1-7.206 3.33"
  })));
};
export default SvgLogoMini;